var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4344_22887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 110,
    height: 110
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 110C66.5674 110.009 73.0717 108.719 79.1391 106.206C85.2065 103.693 90.7174 100.005 95.355 95.355C100.005 90.7174 103.693 85.2065 106.206 79.1391C108.719 73.0717 110.009 66.5674 110 60C110.008 53.4327 108.719 46.9285 106.206 40.8611C103.692 34.7937 100.005 29.2828 95.355 24.645C90.7174 19.9951 85.2065 16.3075 79.1391 13.7943C73.0717 11.281 66.5674 9.99153 60 10C53.4327 9.99167 46.9285 11.2812 40.8611 13.7944C34.7937 16.3077 29.2828 19.9952 24.645 24.645C19.9952 29.2828 16.3077 34.7937 13.7944 40.8611C11.2812 46.9285 9.99167 53.4327 10 60C9.99153 66.5674 11.281 73.0717 13.7943 79.1391C16.3075 85.2065 19.9951 90.7174 24.645 95.355C29.2828 100.005 34.7937 103.692 40.8611 106.206C46.9285 108.719 53.4327 110.008 60 110Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60L55 75L85 45",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4344_22887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H120V120H0V0Z",
    fill: "#1AA05B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessIcon);
export default __webpack_public_path__ + "static/media/paymentSuccessIcon.b2752a7fa68c5f2332446f3128bd9e85.svg";
export { ForwardRef as ReactComponent };